import {UUID} from 'yougile-util'
import {DataObjectId} from 'yougile-model'
import {Accounts} from '../../client/accounts'
import {ComponentUpdater} from './index'

export const AccountUpdater: (
  account: DataObjectId | 'all' | 'current'
) => ComponentUpdater = account => {
  return {
    displayName: `Account`,
    onMount(update: () => void): UUID {
      return Accounts.addListener({
        account,
        cb: update
      })
    },
    onUnmount(id: UUID): void {
      Accounts.removeListener(id)
    }
  }
}
